import React from 'react'
import { LoginForm } from "@/components/loginForm"

const LoginPage: React.FC = () => {
  return (
    <div>
      <LoginForm />
    </div>
  )
}

export default LoginPage
